// Iterates current step index

const CurrentStepActions = {
  SET_CURRENT_STEP: 'CurrentStep.SET_CURRENT_STEP',
  RESET_CURRENT_STEP: 'CurrentStep.RESET_CURRENT_STEP',
};

export default CurrentStepActions;
